<template>
    <div style="overflow-x: hidden;background-color: white;">

    <!-- 顶部横幅区域 -->
    <div class="banner1">
        <van-icon class="banner1-back" name="arrow-left" size="30px" @click="goBack" />  
    </div>
    
    <!-- 主体内容区域 -->
    <div class="bodyconten">

        <!-- 标题容器 -->
        <div class="bodyconten-title">
            <p>Marketing Network</p>
        </div>

        <!-- 地图容器 -->
        <div id="map" class="bodyconten-content">
        </div>

    </div>


          <!-- Vant 底部弹出层 -->
            <van-popup v-model="popupVisible" position="bottom" round :style="{ height: '63%' }"  :overlay="true"  :close-on-click-overlay="true">
                <div class="popup-content">
                    
                    <div class="popup-content-top"> 
                        <van-icon class="popup-back" name="arrow-left" size="20px" @click="closePopup" />  
                         <h3>{{ selectedCity.companyen }}</h3>
                        </div>

                   <div class="popup-content-contact">
                    <p><span class="popup-content-contact-title"> Qualification:</span>{{ selectedCity.qualificationen }}</p>
                    <p><span class="popup-content-contact-title">Address:</span>{{ selectedCity.addressen }}</p>
                    <p><span class="popup-content-contact-title">Phone:</span>{{ selectedCity.phone }}</p>
                    <p><span class="popup-content-contact-title">Email:</span>{{ selectedCity.email }}</p>             
                   </div>
                    
                    <div class="popup-content-img"><img :src="selectedCity.imgurl" alt=""></div>
                    <p><a :href="selectedCity.link" target="_blank" style="font-size: 13px;">>more</a></p>
                </div>
                <div v-if="popupVisible" style="width: 100vw;">
                    <bottomh5></bottomh5>
                    </div>
            </van-popup>

            <div style="width: 100vw;">
                <bottomh5></bottomh5>
                </div>
    </div>
</template>
<script>
import bottomh5 from'@/view/h5/public/bottomh5en.vue'
import bottomcontent from'@/view/h5/public/bottomcontent.vue'
import axios from 'axios';
import apiUrls from '@/http/http';
import { Dialog, Toast,Popup  } from "vant";
// 在组件中导入 Leaflet
import L from 'leaflet';
        import 'leaflet/dist/leaflet.css';  // 导入样式
export default {
    components:{
        bottomh5,
        bottomcontent
        },
        data() {
        return {
                // 天地图服务的密钥
                tk: 'bcdfd077a80733b5d581fce12fc92dc7',
                map: null,
                popupVisible: false, // 控制底部弹窗
                 selectedCity: {}, // 选中的城市信息
                cities: [
                    { name: '贵州', lat:26.563152 , lon: 105.035520,companyen:'贵州铭恒新材料有限公司',  company: '贵州铭恒新材料有限公司',  qualificationen: '暂无' ,qualification: '旗舰工厂' ,addressen:'暂无',address: '贵州省六盘水市水城经济开发区铝产业园',phone:'020-39390239-312',email:'moc@mingheng-group.com', imgurl:'http://192.168.0.53/dev-api/profile/upload/2024/10/22/pic-GUIZHOU%20factory1_20241022111501A009.jpg',link:'https://www.mingheng-group.com/'},
                    { name: '广州', lat: 23.1291, lon: 113.2644,companyen:'广州谱褀商业发展有限公司', company: '广州谱祺商业发展有限公司',qualificationen: 'Puki Brand Operation Entity' ,qualification: '谱祺品牌运营主体' ,addressen:'Room122,1/F,Chengzhuo Building, No.169, Haibin RoadNansha Free Trade Zone, Guangzhou, China.', address: '广州市南沙自贸区海滨路169号122单元',phone:'86/20/3939 0239',email:'coop@puki.vip', imgurl:'http://192.168.0.53/dev-api/profile/upload/2024/10/22/pic-PUKI%20exhibition%20center2_20241022104847A005.jpg',link:'https://puki.vip/'},

                ],
            
            }
    },
    mounted() {
    
        this.fetchData();

            // 初始化地图，将视图设置为中国的中心（经纬度：35.8617, 104.1954），并设置适当的缩放级别
        this.map = L.map('map').setView([23.1291, 113.2644], 5); // 中心设置为广州的中心，缩放级别为5
            // 添加天地图的底图
            this.addTileLayer();
    },
    watch: {
            // 监听 isEnglish 变化
            isEnglish(newVal) {
            },
        },
    computed: {

    
    },
    methods:{   
        async fetchData() {
            try {
                // 发起 API 请求
                const response = await axios.get(`${apiUrls.baseUrl}/website/api/salesnetwork`);
                const data = response.data;
                // console.log(data)
                if (data && data.length > 0) {
                    // 处理 banner 图片
                    // this.imageUrlone = `${apiUrls.devApi}${data[0].imageUrlone}`;
                    //天地图
                    this.tk=data[0].tk;
                    
                    this.cities=[];
                this.cities = data.map(city => ({
                    name: city.name,
                    lat: city.lat,
                    lon: city.lon,
                    company: city.company,
                    companyen: city.companyen,
                    qualification: city.qualification,
                    qualificationen: city.qualificationen,
                    address: city.address,
                    addressen: city.addressen,
                    phone: city.phone,
                    email: city.email,
                    imgurl: `${apiUrls.baseUrl}${city.imgurl}`, // 动态拼接图片的完整路径
                    link: city.link,
                })) .sort((a, b) => {
                        // 如果 `company` 为目标值，将其排在最后
                        if (a.company === "广州谱祺商业发展有限公司") return 1;
                        if (b.company === "广州谱祺商业发展有限公司") return -1;
                        return 0; // 其他顺序保持不变
                    });
                    
                this.addCityMarkers();
                   
                }
            } catch (error) {
                console.error('获取数据失败:', error);
            }
        },
        goBack() {
window.history.back(); // 让浏览器返回上一页
},
                // 显示弹窗
        closePopup() {
this.popupVisible = false;
},      
                // 地图开始————————————————————————————————————————————————————————————————————
        
            // 添加天地图底图
                addTileLayer() {
            // 矢量底图
            const vecLayer = L.tileLayer(
                    `http://t0.tianditu.gov.cn/vec_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=${this.tk}`,
                    {
                        maxZoom: 18,
                        minZoom: 1,
                        tileSize: 256,
                        zoomOffset: 0,
                        attribution: '&copy; 天地图 矢量底图',
                    }
            );

            // 影像底图
            const imgLayer = L.tileLayer(
                    `http://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=${this.tk}`,
                    {
                        maxZoom: 18,
                        minZoom: 1,
                        tileSize: 256,
                        zoomOffset: 0,
                        attribution: '&copy; 天地图 卫星底图',
                    }
            );

            // 地形底图
            const terLayer = L.tileLayer(
                    `http://t0.tianditu.gov.cn/ter_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=ter&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=${this.tk}`,
                    {
                        maxZoom: 18,
                        minZoom: 1,
                        tileSize: 256,
                        zoomOffset: 0,
                        attribution: '&copy; 天地图 地形底图',
                    }

                
            );

                // 默认加载矢量底图
                vecLayer.addTo(this.map);

                // 图层控制
                L.control.layers({
                    '矢量': vecLayer,
                    '卫星': imgLayer,
                    '地形': terLayer,
                }).addTo(this.map);

                this.addCityMarkers();
                },
            // 添加城市标记
            addCityMarkers() {

                const customIcon = L.icon({
                    iconUrl: require('leaflet/dist/images/marker-icon-2x.png'), // 蓝色图标
                    iconSize: [20, 30],
                    iconAnchor: [16, 32],
                    popupAnchor: [0, -32]
                });



            this.cities.forEach((city) => {// 使用箭头函数，确保 this 是当前 Vue 实例

                let popupContent = `  `; // 判断是否有公司信息，若有则显示
                  // 添加 marker 并绑定空 popup，再立即关闭
                const marker = L.marker([city.lat, city.lon], { icon: customIcon })
                    .addTo(this.map)
                    .bindPopup("")
                    .openPopup(); // 隐藏默认的 popup

                        // // 点击事件，显示底部弹窗
                        marker.on('click', () => {
                            console.log("________________");
                            console.log( city.company);
                                //打开vant-popup弹窗
                                this.popupVisible = true;
                                this.selectedCity=city;
                                console.log("________________");
                            });
            });
            },


                // 地图结束————————————————————————————————————————————————————————————————————————
    }
}
</script>

<style scoped>
/deep/.leaflet-fade-anim .leaflet-map-pane .leaflet-popup{
opacity: 0!important;
}
/deep/.el-menu{
padding-left: 3.5vw;
}
.scroll-container {
overflow-y: scroll;
-webkit-overflow-scrolling: touch; /* 支持iOS惯性滚动 */
scroll-behavior: smooth; /* 平滑滚动效果 */
overflow-x: hidden;
}
/* ===== 基础样式重置 ===== */
/* 移除浏览器默认样式，确保页面在各浏览器中有一致的基础样式 */
body {
margin: 0; /* 移除浏览器默认的外边距 */
padding: 0; /* 移除浏览器默认的内边距 */
/* 不设置字体以继承浏览器默认字体，如需设置特定字体可在此添加 */
}

/* ===== 全局容器样式 ===== */
/* Vue 应用的根容器样式 - 整个应用的外层容器 */
.container {
padding: 0; /* 移除内边距，确保内容紧贴边缘 */
margin: 0; /* 移除外边距，确保容器紧贴浏览器边缘 */

/* 注意：position:relative 使子元素的绝对定位以此元素为参考点 */
/* 默认为 static 定位，不创建新的定位上下文 */
}

/* ===== 顶部横幅区域样式 ===== */
/* 页面顶部的图片背景区域，作为页面的视觉入口 */
.banner1 {
/* 背景设置 - 层叠多种背景属性确保视觉效果 */
background-color: green; /* 设置备用背景颜色，图片加载失败时显示 */
background-image: url('@/assets/salesnetworkh5banner.png'); /* 设置横幅背景图片 */


/* 关键属性，确保背景铺满但不变形 */
background-size: cover; /* 让背景图片填充整个容器，可能裁剪部分 */
background-position: center; /* 居中对齐，避免偏移 */
background-repeat: no-repeat; /* 防止图片重复 */

/* 尺寸设置 - 控制横幅的大小 */
width: 100vw; /* 宽度设置为视口宽度，确保横幅占满屏幕宽度 */
height: 230px; /* 设置固定高度，与设计稿保持一致 */

/* 间距控制 - 确保没有多余空间 */
margin: 0; /* 移除外边距，确保紧贴容器边缘 */
padding: 0; /* 移除内边距，确保内容紧贴边缘 */

/* 定位设置 - 为子元素提供定位上下文 */
position: relative; /* 建立定位上下文，使 logo 可以相对横幅定位 */
/* 不设置z-index，让堆叠顺序由DOM顺序决定 */
}
.banner1 .banner1-back{
position: absolute;
top: 60px;
left: 10px;
color: white;
}


/* ===== 主体内容区域样式 ===== */
/* 页面主要内容的容器，包含所有信息展示和交互元素 */
.bodyconten {
/* 外观样式 - 设置主体区域的视觉呈现 */
border-radius: 30px 30px 0 0; /* 设置上方圆角：左上、右上20px */
background-color: rgb(247, 245, 245); /* 设置白色背景 */

/* 尺寸设置 - 控制主体区域大小 */
height: 660px; /* 设置固定高度，确保足够的内容空间 */
width: 100vw; /* 宽度设置为视口宽度，确保占满屏幕 */

/* 位置控制 - 调整与上方元素的关系 */
margin-top: -80px; /* 负边距使内容向上偏移，与横幅重叠 */

/* 定位和层级 - 建立层级关系 */
position: relative; /* 建立定位上下文，为子元素提供定位参考 */
z-index: 2; /* 设置层级高于横幅，但低于logo */


}

.bodyconten-title{
border-radius: 30px 30px 0 0; /* 设置上方圆角：左上、右上20px */

height: 40px;
width: 100vw;

display: flex;
justify-content: center;
align-items: center;
}
.bodyconten-title p{
line-height: none;
font-weight: lighter;
color: rgb(87, 88, 88);
}
.bodyconten-content{
width: 100vw;
height: 555px;
background-color: bisque;
}




/********
弹窗
*****/
.popup-content{
display: flex;
justify-content: center;
flex-direction: column;
align-items:flex-start;

width: 85%;

margin: 0 auto;

gap: 15px; /* 控制子元素之间的间距 */
}
.popup-content-top{
height: 50px;
width: 100%;

display: grid;
place-items: center; /* 水平和垂直居中 */

position: relative;

}
.popup-content-top .popup-back{
position: absolute;
left: 0;
font-weight: bold;
}
.popup-content-top h3{
margin: 0; /* 左右自动 margin 实现居中 */
}
.popup-content-contact{

width: 100%;

display: flex;
flex-direction: column;
align-items: flex-start; /* 左对齐 */
gap: 5px; /* 控制子元素之间的间距 */
}
.popup-content-contact p{

    margin: 0;
    font-weight: 400;
    line-height: 1; /* 调整行高，保证可读性 */
   
    max-width: 100%; /* 确保不会超出父级 */
    word-break: break-word; /* 允许长单词在必要时换行 */
    white-space: normal; /* 允许文本换行 */
    overflow-wrap: break-word; /* 确保所有类型的文本都能换行 */
   
}
.popup-content-contact-title{
    display: inline-block; /* 让标题生效，支持宽度 */
    width: 110px; /* 你可以调整合适的宽度 */
   
}

.popup-content-img{
height: 200px;
width: 100%;

}
.popup-content-img img{
height: auto;
width: 100%;

}
</style>